const parseUrl = (url) => {
  const { host, protocol } = new URL(url);
  const hostArr = host.split('.');
  const subdomain = hostArr[0];
  const domain = hostArr.slice(1).join('.');

  return { domain, protocol, subdomain };
};

export const getBaseUrl = () => {
  const { domain, protocol } = parseUrl(window.location.href);
  const apiPath = 'api/v1';

  return `${protocol}//${domain}/${apiPath}`;
};

export default getBaseUrl;
